import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input"]

  async copy(event) {
    try {
      await navigator.clipboard.writeText(this.inputTarget.value)
      event.currentTarget.textContent = "Link copiado"
    } catch (_) {
      this.inputTarget.select()
      event.currentTarget.textContent = "Selecione e copie o link"
    }
  }
}
